const ExclusiveDealsQuery = `
{
  queryExclusiveDealsContents {
    flatData {
      dealsBanners {
        flatData {
          name
          desktopImage {
            url
          }
          tabletImage {
            url
          }
          mobileImage {
            url
          }
        }
      }
      dealsItemsComponents {
        flatData {
          internalName
          title
          description
          backgroundColor
          featuredDealsItem {
            flatData {
              description
              validUntil
              productImage {
                url
              }
              discountPriceImage {
                url
              }
              providerImage {
                url
              }
              price
              wasPrice
              hasPrice
            }
          }
          dealItems {
            flatData {
              description
              validUntil
              productImage {
                url
              }
              discountPriceImage {
                url
              }
              providerImage {
                url
              }
              price
              wasPrice
              hasPrice
            }
          }
        }
      }
    }
  }
}

`

export default ExclusiveDealsQuery
